import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Col, Container, Row, Footer } from 'mdbreact';
import {Link} from "react-router-dom";

class FooterPage  extends Component {
    render() {
        return (
            <Footer color="blue-grey" className="page-footer font-small lighten-5 pt-0">
                <div style={{backgroundColor: '#f6581d'}}>
                    <Container className="text-right rtl">
                        <Row className="py-4 d-flex align-items-center">
                            <Col xs="12" md="6" lg="5" className="text-center text-md-right mb-4 mb-md-0">
                                <h6 className="mb-0 white-text">با ما همراه شوید</h6>
                            </Col>
                            <Col xs="12" md="6" lg="7" className="text-center text-md-left">
                                <a className="fb-ic ml-0" target="_blank"><i className="fa fa-facebook white-text mr-4"> </i></a>
                                <a className="tw-ic" target="_blank"><i className="fa fa-twitter white-text mr-4"> </i></a>
                                <a className="gplus-ic" target="_blank"><i className="fa fa-google-plus white-text mr-4"> </i></a>
                                <a className="li-ic" target="_blank"><i className="fa fa-linkedin white-text mr-4"> </i></a>
                                <a className="ins-ic" target="_blank"><i className="fa fa-instagram white-text mr-4"> </i></a>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container className="mt-5 mb-4 text-center text-md-right rtl">
                    <Row className="mt-3">
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>آنچه باید بدانید</strong></h6>
                            <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
                            <p><Link to="/rules-of-use" className="dark-grey-text">قوانین استفاده</Link></p>
                            <p><Link to="/hotel-rules" className="dark-grey-text">قوانین استفاده از هتلها</Link></p>
                            <p><Link to="/community" className="dark-grey-text">باشگاه مشتریان</Link></p>
                            <p><Link to="/how-it-works" className="dark-grey-text">پایگاه دانش</Link></p>


                        </Col>
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>اطلاعات اضافی</strong></h6>
                            <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
                            <p><Link to="/business" className="dark-grey-text">کسب و کار</Link></p>
                            <p><Link to="/merchant-partners" className="dark-grey-text">همکاران تجاری</Link></p>
                            <p><Link to="/careers" className="dark-grey-text">فرصت های شغلی</Link></p>
                            {/*<p><Link to="/goods" className="dark-grey-text">کالاها</Link></p>*/}
                        </Col>
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>حقوقی</strong></h6>
                            <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
                            <p><Link to="/licences" className="dark-grey-text">مجوزها</Link></p>
                            <p><Link to="/terms-of-sale" className="dark-grey-text">شرایط فروش</Link></p>
                            <p><Link to="/terms-of-use" className="dark-grey-text">شرایط استفاده</Link></p>
                            <p><Link to="/privacy-policy" className="dark-grey-text">حریم خصوصی</Link></p>

                        </Col>
                        <Col xs="12" md="6" lg="3" xl="3" className="mb-4 dark-grey-text">
                            <h6 className="text-uppercase font-weight-bold"><strong>دسترسی سریع</strong></h6>
                            <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
                            <p><Link to="/about" className="dark-grey-text">درباره ما</Link></p>
                            <p><Link to="/how-it-works" className="dark-grey-text">سوالات متداول</Link></p>
                            <p><Link to="/sitemap" className="dark-grey-text">راهنمای سایت</Link></p>
                            <p><Link to="/contact-us" className="dark-grey-text">تماس با ما</Link></p>

                        </Col>
                    </Row>
                </Container>
                <div className="footer-copyright text-center pt-3 pb-3 special-color-dark " style={{background:'#333'}}>
                    <Container fluid>
                        &copy; {(new Date().getFullYear())} Copyright: <a href="https://holding.atldmo.ir">  Atlantis eCity </a>
                    </Container>
                </div>
            </Footer>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(
    mapStateToProps,
)(FooterPage );



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js